module.exports = __webpack_public_path__ + "img/school-logo.62e958be.png";